import React, { useState, useEffect } from "react";
import "./Navbar.css";

const navItems = [
  { id: "about", label: "About" },
  { id: "equipment", label: "Equipment" },
  { id: "services", label: "Services" },
  { id: "testimonials", label: "Testimonials" },
  { id: "melody-band", label: "A melody Band" },
  { id: "team", label: "Team" },
  { id: "contact", label: "Contact" }
];

const Navbar = () => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const [activeSection, setActiveSection] = useState("");

  // Handle scroll effect
  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 100) {
        setScrolled(true);
      } else {
        setScrolled(false);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    const sectionIds = navItems.map((item) => item.id);

    const updateActiveSection = () => {
      const viewportProbe = window.innerHeight * 0.45;
      let currentSection = "";

      sectionIds.forEach((id) => {
        const section = document.getElementById(id);
        if (!section) {
          return;
        }

        const rect = section.getBoundingClientRect();
        if (rect.top <= viewportProbe && rect.bottom >= viewportProbe) {
          currentSection = id;
        }
      });

      if (!currentSection && window.scrollY + window.innerHeight >= document.body.scrollHeight - 8) {
        currentSection = sectionIds[sectionIds.length - 1];
      }

      setActiveSection(currentSection);
    };

    updateActiveSection();
    window.addEventListener("scroll", updateActiveSection, { passive: true });
    window.addEventListener("resize", updateActiveSection);

    return () => {
      window.removeEventListener("scroll", updateActiveSection);
      window.removeEventListener("resize", updateActiveSection);
    };
  }, []);

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  const closeMobileMenu = (sectionId = "") => {
    setIsMobileMenuOpen(false);
    if (sectionId) {
      setActiveSection(sectionId);
    }
  };

  return (
    <nav
      className={`navbar ${scrolled ? "scrolled" : ""}`}
      id="navbar"
    >
      <div className="nav-container">
        <ul
          className={`nav-links ${isMobileMenuOpen ? "active" : ""}`}
          id="navLinks"
        >
          {navItems.map((item) => (
            <li key={item.id}>
              <a
                href={`#${item.id}`}
                className={activeSection === item.id ? "active" : ""}
                onClick={() => closeMobileMenu(item.id)}
              >
                {item.label}
              </a>
            </li>
          ))}
        </ul>

        <button
          className="mobile-menu-toggle"
          id="mobileMenuToggle"
          aria-label="Toggle mobile menu"
          onClick={toggleMobileMenu}
        >
          ☰
        </button>
      </div>
    </nav>
  );
};

export default Navbar;
